
import { Component, Mixins } from "vue-property-decorator";
import FormAlignmentMGHRWCBase from "./index";

@Component
export default class FormAlignmentMGHRWC extends Mixins(
  FormAlignmentMGHRWCBase
) {}
